import { useRemoteStrings } from '@acorns/web-utils'
import React from 'react'
import { trackRegistrationCreateAccountGoldPrefilledContainerViewedPayload } from 'generated/trackingEvents'
import { useAnalyticsComponentViewed } from 'utils/analytics/useAnalyticsComponentViewed'

import {
  ContextualDetailsContainer,
  ContextualDetailsContainerBackground,
  ContextualDetailsCondensedTitle,
  ContextualDetailsTitle,
  StyledCircleCheckIcon,
} from '../styled-components'

export const AcornsEarlySupplement = () => {
  const { getRemoteString } = useRemoteStrings()

  const event = trackRegistrationCreateAccountGoldPrefilledContainerViewedPayload({
    context: 'acorns_early',
  })
  useAnalyticsComponentViewed({
    generatedPayload: event,
  })

  return (
    <ContextualDetailsContainer>
      <ContextualDetailsTitle>
        <StyledCircleCheckIcon />
        {getRemoteString({
          key: 'early_prefill.create_account.promo_code_card.title',
        })}
      </ContextualDetailsTitle>
      <ContextualDetailsCondensedTitle>
        {getRemoteString({
          key: 'early_prefill.create_account.promo_code_card.description',
        })}
      </ContextualDetailsCondensedTitle>
      <ContextualDetailsContainerBackground />
    </ContextualDetailsContainer>
  )
}
